import i18n from 'locales/i18nManager';

import {
  QuestionnaireCompletePayload,
  QuestionnaireProgressPayload,
  QuestionnaireResponseDTO,
  QuestionnaireSchemaResponse,
} from './models/QuestionnaireDTO';
import { ApiManager } from './ApiManager';

const BASE = '/api/long-form-questionnaire';

export default class ApiQuestionnaireManager {
  static async getSchema(): Promise<QuestionnaireSchemaResponse> {
    const api = ApiManager.getInstance();
    const lang = i18n.language?.slice(0, 2) || 'fr';
    const response = await api.get(`${BASE}/schema/`, { params: { lang } });
    return response.data;
  }

  static async getMyResponse(): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.get(`${BASE}/me/`);
    return response.data;
  }

  static async getResponseForPatient(responseId: number): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const lang = i18n.language?.slice(0, 2) || 'fr';
    const response = await api.get(`${BASE}/${responseId}/`, { params: { lang } });
    return response.data;
  }

  static async createOrResumeResponse(): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.post(`${BASE}/`, {});
    return response.data;
  }

  static async saveProgress(
    responseId: number,
    payload: QuestionnaireProgressPayload,
  ): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.patch(`${BASE}/${responseId}/`, payload);
    return response.data;
  }

  static async complete(responseId: number, payload: QuestionnaireCompletePayload): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.post(`${BASE}/${responseId}/complete/`, payload);
    return response.data;
  }

  static async startReview(responseId: number): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.post(`${BASE}/${responseId}/start-review/`, {});
    return response.data;
  }

  static async markAsReviewed(responseId: number): Promise<QuestionnaireResponseDTO> {
    const api = ApiManager.getInstance();
    const response = await api.post(`${BASE}/${responseId}/mark-as-reviewed/`, {});
    return response.data;
  }

  static async toggleHighlight(responseId: number, questionId: string): Promise<string[]> {
    const api = ApiManager.getInstance();
    const response = await api.post(`${BASE}/${responseId}/toggle-highlight/`, {
      question_id: questionId,
    });
    return response.data.highlighted_question_ids;
  }
}
